module.exports = __webpack_public_path__ + "static/media/ycmsja.dbf189e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/ycmsja.png
// module id = 454
// module chunks = 0